import { forwardRef } from "react";
import {
  NativeDateField,
  formatDateTimeValue,
  parseDateTimeValue,
  type DatePickerProps,
} from "./DatePicker";

export interface DateTimePickerProps extends DatePickerProps {}

export const DateTimePicker = forwardRef<HTMLInputElement, DateTimePickerProps>(
  (props, ref) => (
    <NativeDateField
      ref={ref}
      type="datetime-local"
      formatValue={formatDateTimeValue}
      parseValue={parseDateTimeValue}
      {...props}
    />
  ),
);
DateTimePicker.displayName = "DateTimePicker";
